import CopilotHead from './copilot-extensions-cta/copilotHead'
import Common from './copilot-extensions-cta/common'
import MouseMng from './copilot-extensions-cta/mouseMng'
import Assets from './copilot-extensions-cta/assets'
import Background from './copilot-extensions-cta/background'
// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'

observe('.js-cta-background', canvasElement => {
  const assets = new Assets()
  const canvas = canvasElement as HTMLCanvasElement
  const copilotArea = document.querySelector('.js-copilot-head') as HTMLElement
  const canvasWrapper = document.querySelector('.js-cta-banner > div') as HTMLElement
  const pauseButton = document.querySelector('.js-cta-pause-button') as HTMLElement

  const common = new Common(canvasWrapper, copilotArea, canvas, 2.0)
  const mouseMng = new MouseMng(common)

  const background = new Background(common, assets, false)
  const copilotHead = new CopilotHead(common, assets, mouseMng)
  const buttons = document.querySelectorAll('.js-cta-banner a')

  assets.load(() => {
    background.init()
    copilotHead.init()

    for (const button of buttons) {
      button.addEventListener('mouseenter', () => {
        copilotHead.doHappyReaction()
        background.speedUp()
      })

      button.addEventListener('mouseleave', () => {
        background.speedDown()
      })
    }

    resize()
  })

  // eslint-disable-next-line github/prefer-observers
  window.addEventListener('scroll', () => {
    common.scroll()
  })

  // eslint-disable-next-line github/prefer-observers
  window.addEventListener('resize', () => {
    resize()
  })

  const resize = () => {
    common.resize()
    const z = (common.sizes.y / Math.tan((common.camera.fov * Math.PI) / 360)) * 0.5
    const scale = common.cameraDistance / z
    copilotHead.resize(scale)
    background.resize(scale)
  }

  let isRendering = false
  let isClickedStop = false

  const observer = new IntersectionObserver(entries => {
    if (!isClickedStop) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          toggleRendering(true)
        } else {
          toggleRendering(false)
        }
      }
    }
  })

  const toggleRendering = (_isRendering: boolean) => {
    isRendering = _isRendering
  }

  observer.observe(canvasElement)

  pauseButton?.addEventListener('click', () => {
    isClickedStop = !isClickedStop
    if (isClickedStop && isRendering) {
      toggleRendering(false)
    }

    if (!isClickedStop && !isRendering) {
      toggleRendering(true)
    }
  })

  /**
   * Animate
   */

  const tick = () => {
    common.update()
    if (isRendering) {
      mouseMng.update()
      background.update()

      // Update controls
      copilotHead.update()

      // Render
      common.renderer.setClearColor(0xffffff, 0)
      common.renderer.setRenderTarget(null)
      common.renderer.render(common.scene, common.camera)
    }

    // Call tick again on the next frame
    // animationFrameId = window.requestAnimationFrame(tick)
    window.requestAnimationFrame(tick)
  }

  tick()
})
